<template>
  <div v-if="itemData.companyIcon && itemData.company" class="company">
    <el-tooltip effect="dark" :content="itemData.company" placement="top" :open-delay="1000">
      <div
        :style="{'background':'url('+$handleAssetsUrl(itemData.companyIcon)+') center/contain no-repeat'}"
      >
        <!-- <img
          :src="$handleAssetsUrl(itemData.companyIcon)"
          style="
            height: 100%;
          "
        />-->
      </div>
    </el-tooltip>

    <span>商</span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "sectionCategory",
  mixins: [],
  props: ["itemData", "boxName"],
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["UserEquity"]),
  },
  watch: {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.company {
  width: auto;
  height: 16px;
  overflow: hidden;
  display: flex;
  > div {
    width: 20px;
    height: 16px;
  }
  > span {
    display: inline-block;
    margin-left: 5px;
    width: 20px;
    height: 17px;
    background-color: #5778fb;
    border-radius: 6px 6px 6px 0px;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 17px;
    letter-spacing: 0px;
    color: #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/rightnav/slide/search/company.vue